// Opening hours as the setup and the settings forms edit them (an open/closed switch and up to three ranges per
// day, `HoursEditor.tsx`) and as the dashboard shows them. The rules (validation, past-midnight ranges, open or
// closed, the formatted ranges) are in @ringring/core/venue.
import { UI, WEEK_ORDER, defaultOpeningHours, type HoursRange, type Lang, type OpeningHours, type UiCopy, type Weekday } from '@ringring/core';

export { formatRanges } from '@ringring/core';

export interface DayHours {
  day: Weekday;
  open: boolean;
  /** Never empty: a closed day keeps its last ranges so switching it back on needs no retyping. */
  ranges: HoursRange[];
}

/** The range a day starts with, and the second range offered by "add a range" (an evening service). */
export const FIRST_RANGE: HoursRange = { open: '11:00', close: '23:00' };
export const NEXT_RANGE: HoursRange = { open: '18:00', close: '23:00' };

const DAY_KEYS: Record<Weekday, keyof UiCopy> = { 0: 'day_sun', 1: 'day_mon', 2: 'day_tue', 3: 'day_wed', 4: 'day_thu', 5: 'day_fri', 6: 'day_sat' };

export function dayLabel(lang: Lang, day: Weekday): string {
  return UI[lang][DAY_KEYS[day]];
}

/** The form rows, Monday first, every range of each day. A closed day keeps the default range. */
export function daysFromHours(h: OpeningHours | null): DayHours[] {
  const base = h ?? defaultOpeningHours();
  return WEEK_ORDER.map((day) => ({ day, open: base[day].length > 0, ranges: base[day].length > 0 ? base[day].map((r) => ({ ...r })) : [{ ...FIRST_RANGE }] }));
}

/** The `opening_hours` body of the setup and settings requests: only open days, all their ranges. */
export function hoursFromDays(days: readonly DayHours[]): Record<string, HoursRange[]> {
  const out: Record<string, HoursRange[]> = {};
  for (const d of days) if (d.open) out[String(d.day)] = d.ranges.map((r) => ({ ...r }));
  return out;
}
